const processSummary = (
  <div className="application-process-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">The Application Process</h3>
      <ol className="list-decimal pl-6">
        <li>Find job openings across different sources</li>
        <li>Submit online applications with your resume</li>
        <li>
          Complete Online Assessment (OA)
          <ul className="list-disc pl-6 mt-1">
            <li>Online coding challenge testing knowledge of Data Structures and Algorithms</li>
            <li>Completed on your own time</li>
            <li>Sometimes sent automatically after resume submission</li>
          </ul>
        </li>
        <li>Phone screen with recruiter</li>
        <li>
          Live technical interviews
          <ul className="list-disc pl-6 mt-1">
            <li>Usually 1-3 rounds</li>
            <li>Hour-long sessions coding on the spot</li>
          </ul>
        </li>
        <li>
          Behavioral interview
          <ul className="list-disc pl-6 mt-1">
            <li>Non-coding, conversational format</li>
            <li>Assesses teamwork capabilities, alignment with company values</li>
          </ul>
        </li>
      </ol>
    </div>

    {/* <div className="mb-4">
            <h3 className="text-lg font-semibold mb-2">Process Summary</h3>
            <ol className="list-decimal pl-6">
                <li>Find job openings</li>
                <li>Apply with your resume</li>
                <li>Complete Online Assessment (coding task)</li>
                <li>Pass phone screen</li>
                <li>Pass live technical interviews</li>
                <li>Pass behavioral interviews</li>
                <li>Receive offer!</li>
            </ol>
        </div> */}

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Variations</h3>
      <ul className="list-disc pl-6">
        <li>Process may vary between companies</li>
        <li>Some companies skip certain steps or add others</li>
        <li>
          Additional interview types might include:
          <ul className="list-disc pl-6 mt-1">
            <li>Manager chats</li>
            <li>System design interviews</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
);

export default processSummary;
